import React from 'react'

import SessionCustomField from "../../model2/custom-field/session-custom-field"

export type CustomFieldAddFormProto_Props = {
    customField : SessionCustomField

    ignoreScope : boolean
    scope       : any

    onSubmit    : func
}

export default class CustomFieldAddFormProto extends React.Component<CustomFieldAddFormProto_Props, any> {

    public type: any
    public initFormData: any
    public formStructure: any

    constructor(props: CustomFieldAddFormProto_Props) {
        super(props);

        this.type = null; // should be overridden

        const showScope = !props.ignoreScope;

        this.initFormData = {
            name        : '',
            displayName : '',
            scope       : this.props.scope,
            description : '',
            access      : gd.const.customFields.access.EVERYONE
        };

        if (this.props.customField) {
            this.initFormData = {
                name        : this.props.customField.name,
                displayName : this.props.customField.params.displayName,
                scope       : this.props.customField.params.scope,
                access      : this.props.customField.access
            }
        }

        const existingCustomFields = gd.session.customFields.filterByCompany(gd.companyId);

        this.formStructure = {
            fields: {
                name: {
                    type: 'input',
                    isRequired: true,
                    label: 'Name',
                    validator: (val: any) => {
                        let res: any = true;
                        if (val === null || val === undefined || val.trim() === '') {
                            res = 'No valid characters found';
                        } else {
                            const cf = _.find(existingCustomFields.models, cf => cf.name === val.trim());
                            if (!cf || (this.props.customField && cf.id === this.props.customField.id)) res = true;
                            else res = 'Field with this name already exists';
                        }
                        return res;
                    },
                    onUserChange: this.onNameChange
                },
                displayName: {
                    type        : 'input',
                    isRequired  : false,
                    label       : 'Display Name',
                },
                // scope:          { type: 'select', isRequired: false, label: 'Scope',
                //     validator: (val) => {
                //         return !val || val.length === 0 ? 'No scope selected' : true;
                //     }
                // },
                description:    { type: 'input', isRequired: false, label: 'Description'},
                access:         { type: 'select', isRequired: true, label: 'Access'},
                isRequired:     { type: 'boolean', isRequired: false, label: 'Is required'},
            },
            onSubmit: this.onSubmit.bind(this)
        };

        if (showScope) {
            this.formStructure.fields['scope'] = {
                type: 'select',
                isRequired: false,
                label: 'Scope',
                validator: (val: any) => {
                    return !val || val.length === 0 ? 'No scope selected' : true;
                }
            }
        }

        // this.form = new FormManager(formStructure, initFormData); that should happen in field!
    }

    onNameChange = () => {
        this.forceUpdate()
    }

    onSubmit(result: any) {
        console.error("This method should be overridden")
    }
}
